import { Spacing } from '@persona-id/design-tokens';
import { ComponentPropsWithoutRef, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { headingMixins, paragraphMixins } from 'design-system/mixins/text';

export interface HeaderProps {
  children: ReactNode;
  subtitle?: ReactNode;
  variant?: 'title' | 'section';
  actions?: ReactNode;
}

export const HeaderContainer = styled.div<Pick<HeaderProps, 'variant'>>`
  ${paragraphMixins.md};
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:not(:only-child) {
    margin: 0px 0px ${Spacing[4]} 0px;
  }
  ${({ variant }) =>
    variant === 'section' &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.color.border.primary};
    `}
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing[2]};
`;

export const Title = styled.h3<Pick<HeaderProps, 'variant'>>`
  display: flex;
  align-items: center;
  margin: 0px;
  gap: ${Spacing[2]};
  ${({ variant }) => {
    switch (variant) {
      case 'section':
        return paragraphMixins.lgBold;
      case 'title':
      default:
        return headingMixins.sm;
    }
  }}
`;

export const ActionsContainer = styled.div`
  color: ${({ theme }) => theme.color.text.secondary};
  display: flex;
  align-items: center;
  gap: ${Spacing[2]};
`;

const Header = ({
  children,
  variant,
  actions,
  subtitle,
  ...elemProps
}: HeaderProps & ComponentPropsWithoutRef<'div'>) => {
  return (
    <HeaderContainer variant={variant} {...elemProps}>
      <TitleContainer>
        <Title variant={variant}>{children}</Title>
        {subtitle}
      </TitleContainer>
      <ActionsContainer>{actions}</ActionsContainer>
    </HeaderContainer>
  );
};

export const Root = Header;

export default Header;
